import React from "react";

import Hero from "./Hero";

import CreateTicket from "./CreateTicket";

function SupportPage() {
  return (
    <div>
      <Hero />
      <br/>
      <CreateTicket />
    </div>
  );
}

export default SupportPage;
